import React from 'react';

const SettingsHeader = ({ onBack, onLogout }) => {
    return (
        <div className="flex justify-between full-w mb-4">
            <button className="text-gray-500 py-2 cursor-pointer hover:text-gray-700"
                    onClick={onBack}>
                ← Back
            </button>
            <button className="bg-blue-500 text-white py-2 px-4 rounded mr-2"
                    onClick={onLogout}>
                Logout
            </button>
        </div>
    );
};

export default SettingsHeader;
